import React from "react";
import SearchIcon from "@material-ui/icons/Search";
import { Form } from "react-bootstrap";
import { Clear } from "@material-ui/icons";
import { SearchField } from "./SearchComponent.styled";
import { theme as themeConfig } from "../../themes/themes";

const SearchComponent = ({ rSearch, setSearchText, handleSearch }) => {
  return (
    <SearchField>
      <SearchIcon style={{ color: themeConfig.text.primary }} />
      <Form.Control
        type="text"
        placeholder="Search"
        onChange={handleSearch}
        ref={rSearch}
      />
      <Clear
        style={{
          right: "0",
          color: themeConfig.neutral.gray[2600],
          width: "1rem",
          height: "1rem",
          cursor: "pointer",
        }}
        onClick={() => {
          rSearch.current.value = "";
          setSearchText("");
        }}
      />
    </SearchField>
  );
};

export default SearchComponent;
